module.exports = __webpack_public_path__ + "img/dailychemicals_1.750ba009.jpg";